import { NgIf } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { DynamicFormControlComponent, DynamicFormControlEvent, DynamicFormModel } from '@ng-dynamic-forms/core';
import { DynamicMaterialFormComponent } from '@ng-dynamic-forms/ui-material';
import { WINDOW } from 'ngx-window-token';
import { CustomDynamicFormService } from '../../../custom-dynamic-form.service';
import { setModelDisabled } from '../../../helpers/disable-model.helper';
import { formElementsInvalid } from '../../../helpers/form-elements-invalid.helper';
import { AnyFormControlModel } from '../../shared-models/any-form-control.model';

export interface GeschaedigtePersonDialogData {
  formConfig: AnyFormControlModel[];
  heading: string;
  disabled: boolean;
  parentComponent: DynamicFormControlComponent;

  onFormChange?(models: AnyFormControlModel[], changeModel?: AnyFormControlModel);
}

@Component({
  selector:    'gsm-haftpflicht-geschaedigte-person-dialog',
  templateUrl: './haftpflicht-geschaedigte-person-dialog.component.html',
  styleUrls:   ['./haftpflicht-geschaedigte-person-dialog.component.scss'],
  standalone:  true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    NgIf,
    DynamicMaterialFormComponent
  ]
})
export class HaftpflichtGeschaedigtePersonDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<HaftpflichtGeschaedigtePersonDialogComponent, AnyFormControlModel[]>>(MatDialogRef);
  data = inject<GeschaedigtePersonDialogData>(MAT_DIALOG_DATA);
  private formService = inject(CustomDynamicFormService);
  private window = inject<Window>(WINDOW);

  formModel: DynamicFormModel;
  formGroup: UntypedFormGroup;

  formInvalid = true;

  private _isInited = false;

  ngOnInit() {
    this.formModel = this.formService.fromJSON(this.data.formConfig);
    this.formGroup = this.formService.createFormGroup(this.formModel);

    if (this.data.disabled) {
      setModelDisabled(this.formModel, true);
    }

    // wait until form is finished setting up, then trigger onChange
    this.window.setTimeout(() => {
      this._isInited = true;
      this.onChange();
    }, 0);
  }

  onChange(event?: DynamicFormControlEvent) {
    if (this._isInited) {
      this.formInvalid = formElementsInvalid(this.formGroup, this.formModel);
    }

    if (this.data.onFormChange) {
      this.data.onFormChange(this.formModel, event?.model);
    }
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onApplyClick() {
    this.dialogRef.close(this.formModel);
  }
}
